import React from 'react';
import PropTypes from 'prop-types';

const ProjectViewProviderContext = React.createContext();

export const ProjectViewProvider = ({ children, value }) => (
  <ProjectViewProviderContext.Provider value={value}>
    {children}
  </ProjectViewProviderContext.Provider>
);

ProjectViewProvider.propTypes = {
  children: PropTypes.object,
  value: PropTypes.object,
};

export const ProjectViewConsumer = ProjectViewProviderContext.Consumer;



// WEBPACK FOOTER //
// ./src/containers/ProjectView/ProjectView.context.js